// extracted by mini-css-extract-plugin
module.exports = {"root":"dd31006766--root--mZ84I"};